// extracted by mini-css-extract-plugin
export default {"filterWrap":"Groups_filterWrap__MD0nh","createBtnWrap":"Groups_createBtnWrap__nJSpy","plusIcon":"Groups_plusIcon__svbSo"};